import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth-config";

export const SignInButton = () => {
    const { instance } = useMsal();

    return (
        <div>
            <button
                onClick={(_) => instance.loginRedirect(loginRequest)}
                color="inherit"
                className="btn btn-link navbar-brand"
            >
                Login
            </button>
        </div>
    )
}